"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveViewExceedModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _pittaDesignSystem = require("@thingsw/pitta-design-system");
var _styles = require("@material-ui/core/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _withStyleProvider = require("../hoc/withStyleProvider");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    modalTitle: _defineProperty({
      minHeight: 16,
      padding: "25px 40px 0 24px"
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), _objectSpread({}, theme.direction === "rtl" ? {
      padding: "25px 24px 0 13px"
    } : {
      padding: "25px 13px 0 24px"
    })),
    exceedModalRoot: {
      minWidth: 288,
      margin: 16
    },
    exceedModalContentDiv: {
      maxWidth: 450,
      padding: "16px 24px 57px"
    },
    // mantis - 10500, 모바일일 때 하단 버튼 가운데 정렬 (Leehj)
    btnWrap: _defineProperty({
      justifyContent: "center"
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      justifyContent: "flex-end"
    }),
    btn: {
      minWidth: 139,
      whiteSpace: "nowrap"
    }
  };
});
var LiveViewExceedModal = (0, _withStyleProvider.withStyleProvider)(function (_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onClickPositive = _ref.onClickPositive,
    onClickNegative = _ref.onClickNegative,
    t = _ref.t;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
    open: open,
    close: true,
    onClose: onClose,
    onClickPositive: onClickPositive,
    onClickNegative: onClickNegative,
    heading: t("Are you running_Liveview"),
    content: t("Upgrade your plan_Liveview"),
    LButton: t("Stay"),
    RButton: t("Go to Fleet Plan"),
    titleClassName: classes.modalTitle,
    className: classes.exceedModalRoot,
    contentClassName: classes.exceedModalContentDiv,
    RButtonClassName: classes.btn,
    LButtonClassName: classes.btn,
    actionClassName: classes.btnWrap
  });
});
exports.LiveViewExceedModal = LiveViewExceedModal;